
import { ArrowRight, Github, Linkedin, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { useEffect, useState } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useIsMobile();
  
  useEffect(() => {
    // Trigger animations after component mounts
    setIsVisible(true);
  }, []);

  return (
    <section id="home" className="min-h-screen flex flex-col justify-center pb-12 sm:pb-20 pt-24 sm:pt-28 overflow-hidden relative">
      <div className="hero-vector hero-vector-1"></div>
      <div className="hero-vector hero-vector-2"></div>
      
      <div className="container mx-auto px-4 md:px-6 flex justify-center relative z-10">
        <div className="max-w-3xl text-left w-full">
          <p 
            className={`heading-highlight mb-3 sm:mb-5 transition-all duration-500 delay-[200ms] ${
              isVisible ? 'opacity-100 translate-y-0 fade-up' : 'opacity-0 translate-y-8'
            }`}
          >
            Hi, my name is
          </p>
          <h1 
            className={`text-3xl sm:text-4xl md:text-6xl font-bold mb-4 sm:mb-6 transition-all duration-500 delay-[400ms] ${
              isVisible ? 'opacity-100 translate-y-0 fade-up' : 'opacity-0 translate-y-8'
            }`}
          >
            Aniket Kasale.
            <br />
            <span className="text-muted-foreground text-2xl sm:text-4xl md:text-5xl">Building scalable products and delightful user experiences.</span>
          </h1>
          <p 
            className={`text-muted-foreground text-base sm:text-lg mb-6 sm:mb-8 max-w-xl transition-all duration-500 delay-[600ms] ${
              isVisible ? 'opacity-100 translate-y-0 fade-up' : 'opacity-0 translate-y-8'
            }`}
          >
            I'm a Frontend Engineer with over 5 years of experience. I enjoy turning complicated technical requirements into clean, accessible interfaces. Currently building at Interface Infosoft Solutions.
          </p>
          
          <div 
            className={`flex flex-wrap gap-3 sm:gap-4 mb-8 sm:mb-12 transition-all duration-500 delay-[800ms] ${
              isVisible ? 'opacity-100 translate-y-0 fade-up' : 'opacity-0 translate-y-8'
            }`}
          >
            <Button 
              asChild 
              size={isMobile ? "default" : "lg"} 
              variant="outline" 
              className="hover:scale-105 transition-transform"
            >
              <a href="#contact">Get In Touch</a>
            </Button>
          </div>
          
          <div 
            className={`flex space-x-4 transition-all duration-500 delay-[1000ms] ${
              isVisible ? 'opacity-100 translate-y-0 fade-up' : 'opacity-0 translate-y-8'
            }`}
          >
            <a 
              href="https://github.com/aniketkasale" 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-2 rounded-full border border-border/50 hover:border-accent/50 hover:scale-110 transition-all"
              style={{ animationDelay: '1200ms' }}
            >
              <Github className="w-5 h-5" />
              <span className="sr-only">Github</span>
            </a>
            <a 
              href="https://www.linkedin.com/in/aniket-kasale/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-2 rounded-full border border-border/50 hover:border-accent/50 hover:scale-110 transition-all"
              style={{ animationDelay: '1300ms' }}
            >
              <Linkedin className="w-5 h-5" />
              <span className="sr-only">LinkedIn</span>
            </a>
            <a 
              href="mailto:aniketkasale02@gmail.com" 
              className="p-2 rounded-full border border-border/50 hover:border-accent/50 hover:scale-110 transition-all"
              style={{ animationDelay: '1500ms' }}
            >
              <Mail className="w-5 h-5" />
              <span className="sr-only">Email</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
